import {combineReducers} from "redux"

import login from "./LoginReducer";
import budget from "./BudgetReducer";
import report from "./ReportReducer";
import loading from "./LoadingReducer";
export const reducers = combineReducers({login, budget, report, loading});